import { Component, ViewChild } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { ObjectsService } from '@services/http/objects.service';
import { StateService } from '@services/state.service';

/*Models*/
import { ObservableObject } from '@models/observable-object';


/*Plugins */
import { BsModalComponent } from 'ng2-bs3-modal';
declare var swal: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'change-object-name-modal',
  templateUrl: './change-object-name-modal.component.html'
})

export class ChangeObjectNameModalComponent {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('changeObjectNameModal') changeObjectNameModal: BsModalComponent;

  objectNameModel;

  errorMessage;
  observableObject: ObservableObject;
  btnText: any = {
    text: 'Обновить',
    defaultText: 'Обновить',
    loadText: 'Обработка..'
  };
  trySend = false;

  constructor(
    private objectsService: ObjectsService,
    private stateService: StateService,
  ) {
    this.stateService.observableObjectObservable
      .takeUntil(this.ngUnsubscribe)
      .subscribe(object => {
        this.observableObject = object;
      });
  }
  submit() {
    this.trySend = true;
    if (!this.objectNameModel) {
      return false;
    }
    this.btnText.text = this.btnText.loadText;

    this.objectsService.changeObject(
      this.objectNameModel,
      this.observableObject.observableObjectType,
      this.observableObject.extra,
      this.observableObject.id)
      .subscribe(response => {
        this.observableObject.name = this.objectNameModel;

        this.stateService.setCurrentObject(this.observableObject);

        this.close();
        swal({
          type: 'success',
          text: 'Марка и модель изменена',
          showConfirmButton: false,
          timer: 3000,
        });
      },
        error => {
          let errorMessage = 'Ошибка, повторите позже';
          if (error.error) {
            error = error.error;
          }
          if (error.errorMessage && error.errorMessage.length > 0) {
            errorMessage = error.errorMessage;
          }
          this.errorMessage = errorMessage;
          this.trySend = false;
          this.btnText.text = this.btnText.defaultText;
        }
      );
  }

  open() {
    this.errorMessage = null;
    this.objectNameModel = undefined;
    this.changeObjectNameModal.open();
  }

  close() {
    this.changeObjectNameModal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/view/modal/change-object-name/change-object-name-modal.component.ts